<template>
  <div class="status-inline text-capitalize" :class="statusClass" :title="titleText">
    <span class="status-dot" aria-hidden="true"></span>
    <span class="status-text">{{ displayText }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getStatusColor } from "@/shared/utils/utils";

const props = defineProps<{
  status: string;
  label?: string;
  title?: string;
}>();

const statusClass = computed(() => getStatusColor(props.status || ""));
const displayText = computed(() => {
  if (props.label) return props.label;
  if (props.status === "cancel_request") return "cancellation";
  return props.status || "-";
});
const titleText = computed(() => props.title || displayText.value);
</script>

<style scoped>
.status-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  text-transform: capitalize;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
  display: inline-block;
  flex: 0 0 auto;
}

.status-text {
  line-height: 1;
  font-size: 13px;
}

.status-inline.success {
  color: #16a34a;
}

.status-inline.warning {
  color: #f59e0b;
}

.status-inline.error {
  color: #dc2626;
}

.status-inline.info {
  color: #2563eb;
}

.status-inline.primary {
  color: #7c3aed;
}

.status-inline.secondary {
  color: #475569;
}

.status-inline.accent {
  color: #0284c7;
}
</style>
